import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store/index'
import i18n from './plugins/i18n'

import './plugins/index'

Vue.config.productionTip = false

export default new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
